import styled from 'styled-components';
import { DraggableBoxes } from 'ui/draggableBoxes';
import { body2, colors, spacing, caption } from 'ui/theme';
import { Link, sharedLinkCSS } from 'ui/links';
import { pxToRem } from 'utils/convert';
import { OverflowMenu } from 'ui/actionMenu';
import { StyledOptions } from 'ui/actionMenu/ActionMenu.styles';
import { DividedList, DividedListElement, GreyCaption } from './DisplayPriorityTakeover.styled';

export const CampaignDetails = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: ${spacing.eighth};
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${DividedList} {
    margin-bottom: 0;
  }
`;

export const BaseDetails = styled.div`
  ${body2};
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const JourneyDetails = styled(BaseDetails)`
  ${caption};
`;

export const OrderElementWrapper = styled.div`
  display: grid;
  grid-template-columns: 420px 244px 130px minmax(100px, 1fr);
  margin: ${spacing.quarter} 0 ${spacing.quarter} ${spacing.base};
`;

export const StyledDividedListElement = styled(DividedListElement)`
  gap: ${spacing.eighth};
`;

export const StyledCurrentCampaignListElement = styled(DividedListElement)`
  height: ${spacing.plusHalf};
  align-items: center;
  padding-left: ${spacing.single};
`;

export const StyledButtonsColumn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${spacing.half};
`;

export const StyledDraggableBoxes = styled(DraggableBoxes)`
  margin: ${spacing.plusHalf} 0;
`;

export const StyledCampaignDetailsColumn = styled.div`
  display: flex;
  align-items: center;
  grid-column-start: 1;
  grid-column-end: 1;
  padding-right: ${spacing.base};
`;

export const StyledEligibiltyColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  grid-column-start: 2;
  grid-column-end: 2;
  padding-right: ${spacing.base};
  gap: ${spacing.quarter};
`;

export const StyledStartDateColumn = styled.div`
  display: flex;
  align-items: center;
  grid-column-start: 3;
  grid-column-end: 3;
  padding-right: ${spacing.base};
`;

export const StyledDisplayUntilColumn = styled.div`
  display: flex;
  align-items: center;
  grid-column-start: 4;
  grid-column-end: 4;
  justify-content: space-between;
`;

export const StyledEstimatedSendBox = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledDisplayUntilText = styled(GreyCaption)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: ${spacing.half};
`;

export const StyledSkeleton = styled.div`
  height: ${spacing.base};
  width: ${pxToRem(100)};
  border-radius: ${spacing.half};
`;

export const StyledLink = styled(Link)`
  color: ${colors.textSecondary} !important;
  text-decoration-color: ${colors.textSecondary} !important;
  ${sharedLinkCSS}
  ${caption}
`;

export const StyledAction = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${spacing.half};
`;

export const StyledOverflowMenu = styled(OverflowMenu)`
  ${StyledOptions} {
    width: ${pxToRem(216)};
  }
`;

export const StyledDisplay = styled.div`
  gap: ${spacing.quarter};
`;
